import { render, staticRenderFns } from "./pipeline_security_dashboard.vue?vue&type=template&id=40f1460e&"
import script from "./pipeline_security_dashboard.vue?vue&type=script&lang=js&"
export * from "./pipeline_security_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports